import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import SportPage from "@/pages/SportPage";
import NewsPage from "@/pages/NewsPage";
import EducationPage from "@/pages/EducationPage";
import EducationDetail from "@/pages/EducationDetail";
import EbookPage from "@/pages/EbookPage";
import MembershipPage from "@/pages/MembershipPage";
import SchedulePage from "@/pages/SchedulePage";
import AboutPage from "@/pages/AboutPage";
import StrategyPage from "@/pages/StrategyPage";
import ResponsiblePage from "@/pages/ResponsiblePage";
import LeaderboardPage from "@/pages/LeaderboardPage";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AdminDashboard from "@/pages/AdminDashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import MembersPage from "@/pages/MembersPage";
import GamePage from "@/pages/GamePage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App min-h-screen bg-[#0A0B0E]">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/news" element={<NewsPage />} />
              <Route path="/education" element={<EducationPage />} />
              <Route path="/education/:slug" element={<EducationDetail />} />
              <Route path="/ebook" element={<EbookPage />} />
              <Route path="/membership" element={<MembershipPage />} />
              <Route path="/schedule" element={<SchedulePage />} />
              <Route path="/strategy" element={<StrategyPage />} />
              <Route path="/responsible" element={<ResponsiblePage />} />
              <Route path="/leaderboard" element={<LeaderboardPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/game/:league/:id" element={<GamePage />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/members" element={<ProtectedRoute><MembersPage /></ProtectedRoute>} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute adminOnly>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route path="/:sport" element={<SportPage />} />
            </Routes>
          </main>
          <Footer />
          <Toaster theme="dark" position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
